import { apiGet, apiPatch, apiPost } from 'shared/services/api/resource';
import { DEFAULT_CANCELLATION_POLICY, MOCK_RESERVATIONS } from 'modules/arena/reservations/content';
import { Reservation } from 'modules/arena/reservations/types';

export interface ManualReservationInput {
  courtName: string;
  sport: string;
  dateLabel: string;
  timeLabel: string;
  durationLabel: string;
  responsiblePlayer: string;
  totalAmount: number;
  paymentMethod: string;
}

function createReservationId() {
  return `#${Math.floor(10000 + Math.random() * 89999)}`;
}

export function fetchReservations(): Promise<Reservation[]> {
  return apiGet(MOCK_RESERVATIONS, '/arena/reservations');
}

export function updateReservation(id: string, patch: Partial<Reservation>) {
  return apiPatch({ id, ...patch }, `/arena/reservations/${id}`, patch);
}

// Recepção (e a própria arena) podem criar uma reserva em nome de um cliente que chega
// presencialmente ou liga — o pagamento já é coletado na hora, então a reserva nasce
// confirmada, sem passar por pending/awaiting_payment.
export function createManualReservation(input: ManualReservationInput): Promise<Reservation> {
  const newReservation: Reservation = {
    id: createReservationId(),
    courtName: input.courtName,
    sport: input.sport,
    dateLabel: input.dateLabel,
    timeLabel: input.timeLabel,
    durationLabel: input.durationLabel,
    responsiblePlayer: input.responsiblePlayer,
    totalAmount: input.totalAmount,
    platformFeeSnapshot: Math.round(input.totalAmount * 0.02 * 100) / 100,
    cancellationPolicySnapshot: DEFAULT_CANCELLATION_POLICY,
    status: 'confirmed',
    createdAtLabel: 'agora · lançada pela recepção',
    participants: [
      {
        name: input.responsiblePlayer,
        amountDue: input.totalAmount,
        amountPaid: input.totalAmount,
        method: input.paymentMethod,
      },
    ],
  };

  return apiPost(newReservation, '/arena/reservations', input);
}
